// import Constant from '../constant'
// import CONF from '../Config'

export default {
  mainState: {
    menuIndex:1,
    subIndex:0
  },
  login_state: false,
  user_name:'',
  access_token: '',
  board_detail:{
    type:-1,
    contentsNo:-1
  },
  contact: {no: 0, namd: '', tel: '', address: '', photo: ''},
  contactlist: {
    pageno: 1, contacts: []
  },
  devicelist: [
    {no: 0, name: '능수관', isconnected: false, numofcheck: 23400, lastscore: 2.5, increase: 0.1, selected: true},
    {no: 0, name: '한식', isconnected: true, numofcheck: 23400, lastscore: 2.5, increase: 0.6, selected: true}
  ],
  ranklist: [
    {name: '능수관', lastscore: 2.5, increase: 1},
    {name: '한식', lastscore: 2.7, increase: 3},
    {name: '중식', lastscore: 2.9, increase:-1},
    {name: '특식', lastscore: 1.5, increase: 0}
  ],
  period: {
    type: 0, // 0: 기간 1: 월 2: 년
    periodtype: 0, // 0: 지난7일 1: 지난30일 2: 지난주 3: 지난달
    year: 2018,
    month: 1,
    startdate: '2018-01-01',
    enddate: '2018-01-01',
    desc: false
  },
  bestmenulist: [
    {name: '능수관', date: '18.4.1', num: 0, score: 5.0},
    {name: '한식', date: '18.3.1', num: 1, score: 5.0},
    {name: '한식', date: '18.3.1', num: 2, score: 5.0},
    {name: '한식', date: '18.3.1', num: 0, score: 5.0}
  ],
  worstmenulist: [
    {name: '한식', date: '18.4.1', num: 1, score: 1.0},
    {name: '특식', date: '18.4.2', num: 2, score: 1.1}
  ],
  menudetailshort: [
    {date: '4.10', values: [
        {score: 3.4, scoreinrease: 0.3, numofcheck: 3456, ncincrease: -34},
        {score: 3.4, scoreinrease: -0.3, numofcheck: 3456, ncincrease: 34},
        {score: 3.4, scoreinrease: 0.3, numofcheck: 3456, ncincrease: -34},
        {score: 3.4, scoreinrease: 0.3, numofcheck: 3456, ncincrease: 34}
      ]
    },
    {date: '4.10', values: [
        {score: 3.4, scoreinrease: 0.3, numofcheck: 3456, ncincrease: -34},
        {score: 3.4, scoreinrease: -0.3, numofcheck: 3456, ncincrease: 34},
        {score: 3.4, scoreinrease: 0.3, numofcheck: 3456, ncincrease: -34},
        {score: 3.4, scoreinrease: 0.3, numofcheck: 3456, ncincrease: 34}
      ]
    },
    {date: '4.10', values: [
        {score: 3.4, scoreinrease: 0.3, numofcheck: 3456, ncincrease: -34},
        {score: 3.4, scoreinrease: -0.3, numofcheck: 3456, ncincrease: 34},
        {score: 3.4, scoreinrease: 0.3, numofcheck: 3456, ncincrease: -34},
        {score: 3.4, scoreinrease: 0.3, numofcheck: 3456, ncincrease: 34}
      ]
    },
    {date: '4.10', values: [
        {score: 3.4, scoreinrease: 0.3, numofcheck: 3456, ncincrease: -34},
        {score: 3.4, scoreinrease: -0.3, numofcheck: 3456, ncincrease: 34},
        {score: 3.4, scoreinrease: 0.3, numofcheck: 3456, ncincrease: -34},
        {score: 3.4, scoreinrease: 0.3, numofcheck: 3456, ncincrease: 34}
      ]
    },
    {date: '4.10', values: [
        {score: 3.4, scoreinrease: 0.3, numofcheck: 3456, ncincrease: -34},
        {score: 3.4, scoreinrease: -0.3, numofcheck: 3456, ncincrease: 34},
        {score: 3.4, scoreinrease: 0.3, numofcheck: 3456, ncincrease: -34},
        {score: 3.4, scoreinrease: 0.3, numofcheck: 3456, ncincrease: 34}
      ]
    }
  ],
  ranks: [
    {rank: 1, score: 3.4, numofcheck: 2000, menuname: '특식', date: '2.35', menu: '수수밥<br>근대된장국<br>닭고기알감자조림주부조림가지양파볶음<br>두부조림<br>가지양파볶음<br>깍두기'},
    {rank: 1, score: 3.4, numofcheck: 2000, menuname: '특식', date: '2.35', menu: '수수밥<br>근대된장국<br>닭고기알감자조림주부조림가지양파볶음<br>두부조림<br>가지양파볶음<br>깍두기'},
    {rank: 1, score: 3.4, numofcheck: 2000, menuname: '특식', date: '2.35', menu: '수수밥<br>근대된장국<br>닭고기알감자조림주부조림가지양파볶음<br>두부조림<br>가지양파볶음<br>깍두기'},
  ],
  devicesetting: '',
  account: {
    id: '1',
    name: '2',
    organization: '3',
    mobile: '4',
    tel: '5',
    license_image_url: ''
  },
  colortable: [ ]
}



// WEBPACK FOOTER //
// ./src/store/state.js